module.exports = __webpack_public_path__ + "media/images/flags/bj-e8591ed7d23999de96ef5e714b0fffee.svg";